<p-dialog header="交貨註記: DoNo： {{doNo}}" [style]="{width: '40vw'}" [(visible)]="showShipNotes" appendTo="body" (onHide)="hideDialog($event)" [modal]="true" [resizable]="true" [draggable]="false">
  <span class="p-text-secondary block mb-5"><hr style="margin-bottom: 20px;"></span>
  <div *ngFor="let shippingnote of this.shippingNotesList; let i = index" style="margin-bottom: 8px; font-size: 20px">
    {{ i + 1 }}. {{ shippingnote }}
  </div>
</p-dialog>
